import { TestResultsResponse } from 'client/sandbox/SandboxClient';
import FormicaInput from 'components/custom/FormicaInput';
import Icon from 'icons/Icon';
import React, { Component } from 'react';
import LanguageUtil from 'util/LanguageUtil';

class SandboxHistoricalSidebar extends Component<Props, State> {
  public state = new State();

  private searchTimeout: NodeJS.Timeout | null = null;

  handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    this.setState({ search: value });
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.setState({ debouncedSearch: value });
    }, 1000);
  };

  getFilteredResults = () => {
    const { testResults } = this.props;
    const { debouncedSearch } = this.state;
    if (!debouncedSearch) return testResults;
    return testResults.filter((result: TestResultsResponse) => result.id.toString().includes(debouncedSearch));
  };

  render() {
    const { selectedResult, setSelectedResult } = this.props;
    const filteredResults = this.getFilteredResults();
    return (
      <div className='flex flex-col gap-2 overflow-scroll'>
        <FormicaInput
          placeholder={LanguageUtil.get({ id: 'pages.sandbox.historical.searchReport', defaultMessage: 'Search Report' })}
          icon='search'
          value={this.state.search}
          onChange={this.handleInputChange}
        />
        <div className='flex flex-col items-start overflow-scroll'>
          {filteredResults.length === 0 ? (
            <div className={'flex items-center justify-center text-f-black-3  w-full h-12 '}>
              <Icon icon={'no-folder'} size={20} />
              {LanguageUtil.get({ id: 'common.label.noResult', defaultMessage: 'No Result Found' })}
            </div>
          ) : (
            filteredResults.map((result: TestResultsResponse) => (
              <button
                onClick={() => setSelectedResult(result)}
                key={result.id}
                className={`w-full border-b border-f-gray-4 text-left py-2 px-5 text-sm leading-none text-f-black-9 flex items-center gap-2 duration-150 hover:bg-f-gray-4 ${result.id === selectedResult?.id && 'bg-f-gray-4'}`}
              >
                <Icon icon='edit_document' width={14} height={14} />#{result.id}
              </button>
            ))
          )}
        </div>
      </div>
    );
  }
}

interface Props {
  testResults: TestResultsResponse[];
  selectedResult: TestResultsResponse | undefined;
  setSelectedResult: (selectedResult: TestResultsResponse) => void;
}

class State {
  search: string = '';
  debouncedSearch: string = '';
}

export default SandboxHistoricalSidebar;
